import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  margin-bottom: 15px;
`;

const GroupLabel = styled.div`
  font-size: 13px;
  color: var(--text-primary);
  font-weight: 600;
  margin-bottom: 10px;
`;

const CheckboxWrap = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: var(--text-secondary);
  margin-bottom: 8px;
  cursor: pointer;
  
  input[type="checkbox"] {
    width: 16px;
    height: 16px;
    accent-color: var(--accent);
    cursor: pointer;
  }
  
  &:hover {
    color: var(--text-primary);
  }
`;

const CheckboxGroupWidget = ({ node }) => {
  const groupLabel = node.content?.label || 'Interessen:';
  const optionsRaw = node.content?.options || "Newsletter,Angebote,Updates";
  const options = optionsRaw.split(',').map(o => o.trim()).filter(Boolean);

  return (
    <Wrapper width={node.style?.desktop?.width || '100%'}>
      {groupLabel && <GroupLabel>{groupLabel}</GroupLabel>}
      {options.map((opt, i) => (
        <CheckboxWrap key={i}>
          <input type="checkbox" defaultChecked={i===0} />
          {opt}
        </CheckboxWrap>
      ))}
    </Wrapper>
  );
};

registry.register('checkbox_group', {
  label: 'Checkbox Gruppe',
  icon: '☑️',
  category: 'forms',
  defaultContent: {
    label: 'Wählen Sie aus:',
    options: 'Option A,Option B,Option C'
  },
  defaultStyle: {
    desktop: { width: '100%' }
  },
  render: CheckboxGroupWidget,
  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Checkbox Daten',
          fields: [
            { name: 'content.label', label: 'Gruppen Titel', type: 'text' },
            { name: 'content.options', label: 'Optionen (Kommasepariert)', type: 'textarea' }
          ]
        }
      ]
    },
    {
      tab: 'style',
      groups: [
        {
          title: 'Layout',
          fields: [
            { name: 'style.desktop.width', label: 'Breite', type: 'text' }
          ]
        }
      ]
    }
  ]
});
